import * as actionTypes from "../actionType/action-type";

const authLogin = (payload) => {

  return {
    type: actionTypes.AUTH_LOGIN,
    payload,
  };
};

const authCheck = () => {
  return {
    type: actionTypes.AUTH_CHECK,
  };
};
const authLogout = () => {
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};
const authSwitchUser = () => {
  return {
    type: actionTypes.AUTH_SWITCHUSER,
  }
}
const authSwitchUserFalse = () => {
  return {
    type: actionTypes.AUTH_SWITCHUSER_FALSE,
  }
}
const isLoading = (payload) => {
  return {
    type: actionTypes.IS_LOADING,
    payload,
  };
};

const activeMenu = (payload) => {
  return {
    type: actionTypes.ACTIVE_MENU,
    payload,
  };
};
const authToken = (payload) => {
  return {
    type: actionTypes.AUTH_TOKEN,
    payload,
  };
};
const setModalShown = () => {
  return {
    type: actionTypes.SET_MODAL_SHOWN,
  };
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  authLogin,
  authCheck,
  authLogout,
  isLoading,
  activeMenu,
  authToken,
  authSwitchUser,
  authSwitchUserFalse,
  setModalShown
};
